import React from 'react'
import { Link } from 'react-router-dom'

import { useProjectSharedDocuments } from '../hooks/useProjectSharedDocuments'
import { hasSharedDocuments, sharedDocumentsUrl, sharedDocumentsView } from '../services/sharedDocuments'

// #883 — « n documents partagés » on the dossier's synthesis, like the study's
// banner: a link to the section of the documents page. Nothing for a viewer who
// has no section.

type Props = {
  projectId: number
  accountType?: string | null
  projectStep?: string | null
  style?: React.CSSProperties
}

export const sharedDocumentsLabel = (count: number): string =>
  count === 0 ? 'Aucun document partagé' : count === 1 ? '1 document partagé' : `${count} documents partagés`

export const SharedDocumentsLink: React.FC<Props> = ({ projectId, accountType, projectStep, style }) => {
  const { documents, isLoading } = useProjectSharedDocuments(projectId, accountType)
  if (!hasSharedDocuments(accountType) || isLoading) return null
  const view = sharedDocumentsView(accountType, projectStep, documents ?? [])
  if (!view) return null
  const count = view.documents.length
  return (
    <Link
      to={sharedDocumentsUrl(projectId)}
      style={{ fontSize: 13, ...style }}
      data-cy="shared-documents-link"
    >
      {sharedDocumentsLabel(count)}
      {count === 0 && view.canAdd ? ' · en partager un' : ''}
    </Link>
  )
}
